import { render, staticRenderFns } from "./course-add.vue?vue&type=template&id=5ab299ce&scoped=true"
import script from "./course-add.vue?vue&type=script&lang=js"
export * from "./course-add.vue?vue&type=script&lang=js"
import style0 from "./course-add.vue?vue&type=style&index=0&id=5ab299ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab299ce",
  null
  
)

export default component.exports